import React, { useState, useEffect } from "react";
import { patch, post } from '../../helpers/httpClient'
import { useOutletContext } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Alert, Badge, Card, Row, Col } from "react-bootstrap";
import { toast } from 'react-toastify';

const UserProfileForm = () => {
  const [user, setState] = useOutletContext();
  const [newUsername, setNewUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [resetSessions, setResetSessions] = useState(false);
  const [error, setError] = useState("");
  const [mustHaveCurrentPassword, setMust] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      setMust(newPassword !== '' || resetSessions === true)
  }, [newPassword, resetSessions])

  useEffect(
      () => setNewUsername(user.name),
      [user.name]
  )

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPassword && !confirmNewPassword) {
        toast.error("Please, confirm your password");
        return;
    }

    if (newPassword !== confirmNewPassword) {
        toast.error("New passwords do not match.");
        return;
    }

    setError("");

    let settings = {};
    if (newPassword !== '') {
        settings.password = newPassword
    }
    if (resetSessions === true) {
        settings.resetSessions = true
    }
    if (user.name !== newUsername) {
        settings.name = newUsername
    }
    if (mustHaveCurrentPassword) {
        settings.currentPassword = currentPassword
    }

    if (Object.keys(settings).length === 0) {
        toast.error('Nothing to submit')
        return
    }

    patch(
        'user-settings',
        settings,
        function(response) {
            if (response.status === 'ok') {
                setState()
                navigate('/')
            } 
            if (response.status === 'error') {
                setError(response.message)
            }
        } 
    )
  };

  const logout = () => {
    post('logout', {token: localStorage.getItem('token')}, () => window.location.href = '/login')
  }

  const CurrentPassword = () => (
    <Form.Group className="form-row-horizontal mb-3" controlId="currentPassword">
        <Form.Label>Current Password <Badge bg="danger">Required</Badge></Form.Label>
        <Form.Control
        type="password"
        placeholder="Enter current password"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        />
    </Form.Group>
  )

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="structure-node-header mb-3">
                <h2 className="m-0">User Profile</h2>
              </div>
              
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="form-row-horizontal mb-3" controlId="iufefkhedb">
                  <Form.Label>Your name</Form.Label>
                  <Form.Control
                    type="text"
                    name="ifeebiwef"
                    placeholder="Enter your name"
                    value={newUsername}
                    onChange={(e) => setNewUsername(e.target.value)}
                  />
                </Form.Group>
                
                <Form.Group className="form-row-horizontal mb-3" controlId="newPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    autoComplete="new-password"
                  />
                </Form.Group>

                <Form.Group className="form-row-horizontal mb-3" controlId="confirmNewPassword">
                  <Form.Label>Confirm New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm new password"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    autoComplete="new-password"
                  />
                </Form.Group>

                <div className="reset-sessions-row mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Reset all sessions for the current user"
                    checked={resetSessions}
                    onChange={(e) => setResetSessions(e.target.checked)}
                    autoComplete="on"
                  />
                </div>

                { mustHaveCurrentPassword && CurrentPassword() }

                <div className="form-actions mt-4">
                  <Button type="submit" className="primary-button m-0">
                    Update Profile
                  </Button>
                  <Button className="primary-button m-0" onClick={logout}>
                    Log out
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UserProfileForm;